import { formatCustomDate } from "helpers/dateTools";
import { creditNotesTypes } from "./creditNotesTypes";
import { addLabelArray } from "helpers/addLabelArray";

const {
  GET_CREDIT_NOTES_SAT_USAGES,
  SET_CREDIT_NOTES_FILTERS,
  GET_CREDIT_NOTES,
  GET_CLIENT_CREDIT_NOTES,
  SELECT_ALL_NOTE_TO_CFDI,
  DESELECT_ALL_NOTE_TO_CFDI,
  TOGGLE_NOTE_TO_CFDI,
  DO_CREDIT_NOTES,
  CLEAR_CREDIT_NOTES,
  GET_DATA_FISCAL,
} = creditNotesTypes

const INITIAL_STATE = {
  startDate: formatCustomDate(new Date(), '-'),
  endDate: formatCustomDate(new Date(), '-'),
  station: [],
  name: "",
  satUsages: [],
  emails: [],
  creditNotesArr: [],
  notesToCfdi: new Set(),
  notesFolio: [],
  notes: [],
  totalNotes: 0,
  totalLiters: 0,
  dataFiscal: {},
  billToAccounts: [],
}

export const creditNotesReducer = (state = INITIAL_STATE, {type, payload}) => {

  switch (type) {

    case GET_CREDIT_NOTES_SAT_USAGES: {
      const filterSat = payload.filter(opt => {
        const firstLetter = opt.code.slice(0,1)
        return firstLetter === "G" || firstLetter === "S"
      })
      return {
        ...state,
        satUsages: addLabelArray(filterSat, "code", "description")
      }
    }
    
    case SET_CREDIT_NOTES_FILTERS:
      return {
          ...state,
          [payload.key]: payload.data,
      };

    case GET_CREDIT_NOTES:
      return {
        ...state,
        creditNotesArr: payload.response,
        name: payload.name
      }

    case GET_CLIENT_CREDIT_NOTES: {
      const filterEmails = payload.emails.filter(x => x)
      const repFilter = [...new Set(filterEmails)]

      return {
        ...state,
        notes: payload?.notes.map(nt => {
          return {
            ...nt,
            date: nt.date.split('.')[0],
          }
        }),
        emails: repFilter.map(i => { return { value: i, label: i} }) || [],
        notesToCfdi: new Set(),
        customer: payload.customer
      }
    }

    case SELECT_ALL_NOTE_TO_CFDI: {
      const newAllNotesToMigrate = new Set(state.notesToCfdi)
      const notesFolioAll = new Set(state.notesFolio); 
      const folioMap = {};
      payload.forEach(note => {
        newAllNotesToMigrate.add(note.id)
        if (!folioMap[note.folio]) {
          folioMap[note.folio] = {
            total: note.total,
            liters: 0
          };
        }
        folioMap[note.folio].liters += note.liters;
        notesFolioAll.add(note.folio);
      })
      const totalAll = Object.values(folioMap)
      .reduce((acc, x) => acc + x.total, 0);
      const totalLitersAll = Object.values(folioMap)
        .reduce((acc, x) => acc + x.liters, 0);

      return {
        ...state,
        notesToCfdi: newAllNotesToMigrate,
        totalNotes: totalAll,
        notesFolio: notesFolioAll,
        totalLiters: totalLitersAll,
      }
    }

    case DESELECT_ALL_NOTE_TO_CFDI:
      return {
        ...state,
        notesToCfdi: new Set(),
        totalNotes: 0,
        notesFolio: new Set(),
        totalLiters: 0,
      }

    case TOGGLE_NOTE_TO_CFDI: {
      const { id, folio } = payload;
      const notesToCfdi = new Set(state.notesToCfdi); 
      const notesFolio = new Set(state.notesFolio); 

      const group = state.notes.filter(n => n.folio === folio);
      const groupTotals = group.reduce(
        (acc, item, index) => {
          if (index === 0) acc.total = item.total; 
          acc.liters += item.liters; 
          return acc;
        },
        { total: 0, liters: 0 }
      );

      const alreadySelected = notesToCfdi.has(id);
      if (alreadySelected) {
        notesToCfdi.delete(id);
        notesFolio.delete(folio);
      } else {
        notesToCfdi.add(id);
        notesFolio.add(folio);
      }
      return {
        ...state,
        notesToCfdi,
        totalNotes: alreadySelected
          ? state.totalNotes - groupTotals.total
          : state.totalNotes + groupTotals.total,
        notesFolio,
        totalLiters: alreadySelected
          ? state.totalLiters - groupTotals.liters
          : state.totalLiters + groupTotals.liters,
      };
    }

    case DO_CREDIT_NOTES: {
      let editNotesState = [...state.creditNotesArr]
      const idx = editNotesState.findIndex(x => x.id === payload.id)
      if(idx !== -1) {
        editNotesState[idx].notesCount -= payload.count 
        if(editNotesState[idx].notesCount  === 0){
          editNotesState = editNotesState.filter(item => item.id !== payload.id)
        }
        return {
          ...state,
          creditNotesArr: editNotesState,
          notesToCfdi: [],
          totalNotes: 0,
        }
      }
      return state
    }
    case CLEAR_CREDIT_NOTES:
      return {
          ...state,
          ...INITIAL_STATE,
      };
    case GET_DATA_FISCAL:
      return {
        ...state,
        billToAccounts: payload.billToAccounts.map(item => ({...item, name: `${item.customerAccountSiteNumber}-${item.alias}`})),
        dataFiscal:  payload
      }
    default :
      return state
  }
}